import { Children, ReactNode } from 'react'

import { Box, Container, Stack, StackProps, rem } from '@mantine/core'

export const HealthToolLayout = ({ children }: { children: ReactNode }) => {
  const allChildren = Children.toArray(children)
  const leftChildren = allChildren.find(
    (c: any) => c.type.columnName === 'left',
  )
  const rightChildren = allChildren.find(
    (c: any) => c.type.columnName === 'right',
  )
  return (
    <Container
      size="lg"
      sx={{ margin: '0 auto', backgroundColor: '#fff', borderRadius: 8 }}
    >
      <Box
        sx={(theme) => ({
          [theme.fn.largerThan('sm')]: {
            display: 'flex',
            justifyContent: 'space-between',
          },
        })}
      >
        {leftChildren && (
          <Box
            sx={(theme) => ({
              [theme.fn.largerThan('sm')]: {
                width: `calc(65% - 24px)`,
              },
            })}
          >
            {leftChildren}
          </Box>
        )}
        {rightChildren && (
          <Box
            sx={(theme) => ({
              [theme.fn.largerThan('sm')]: {
                width: '35%',
              },
            })}
          >
            {rightChildren}
          </Box>
        )}
      </Box>
    </Container>
  )
}

function LeftColumn({
  children,
  ...props
}: { children: ReactNode } & StackProps) {
  return (
    <Stack
      sx={(theme) => ({
        padding: `${rem(16)} 0`,
        gap: rem(24),
        [theme.fn.largerThan('sm')]: {
          padding: `${rem(32)} 0`,
        },
      })}
      {...props}
    >
      {children}
    </Stack>
  )
}
LeftColumn.columnName = 'left'
LeftColumn.displayName = 'HealthToolLayoutLeft'
HealthToolLayout.LeftColumn = LeftColumn
function RightColumn({
  children,
  ...props
}: { children: ReactNode } & StackProps) {
  return (
    <Stack
      sx={(theme) => ({
        [theme.fn.largerThan('sm')]: {
          padding: `${rem(24)} 0`,
        },
      })}
      {...props}
    >
      {children}
    </Stack>
  )
}
RightColumn.columnName = 'right'
RightColumn.displayName = 'HealthToolLayoutRight'
HealthToolLayout.RightColumn = RightColumn
